/**
 * @generated SignedSource<<4c17fa1268309878f3b34eb568c127b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagsSection"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "serviceId",
    "variableName": "serviceId"
  },
  {
    "kind": "Variable",
    "name": "tagsSection",
    "variableName": "tagsSection"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceViewPalacSportuFancyPagesViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "serviceViewPalacSportuFancyPagesViewer_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "serviceViewPalacSportuFancyPagesViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "EndpointConnection",
            "kind": "LinkedField",
            "name": "searchEndpoints",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EndpointEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Endpoint",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [
              "tagsSection",
              "serviceId"
            ],
            "handle": "connection",
            "key": "serviceViewPalacSportu_searchEndpoints",
            "kind": "LinkedHandle",
            "name": "searchEndpoints"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5fc4cb65c6862f4a653d83924e846cc",
    "id": null,
    "metadata": {},
    "name": "serviceViewPalacSportuFancyPagesViewerQuery",
    "operationKind": "query",
    "text": "query serviceViewPalacSportuFancyPagesViewerQuery(\n  $first: Int!\n  $after: String\n  $tagsSection: String\n  $serviceId: String\n) {\n  viewer {\n    ...serviceViewPalacSportuFancyPagesViewer_viewer\n  }\n}\n\nfragment serviceViewPalacSportuFancyPagesViewer_viewer on Viewer {\n  searchEndpoints(first: $first, after: $after, tagsSection: $tagsSection, serviceId: $serviceId) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6ec7f18f1048301d71007a1e7253bdc5";

module.exports = node;
